import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
export function isSubjectPickerSupported() {
    if (isMailFeatureEnabled('peo-subjectPicker') && isTabViewEnabled()) {
        // For now we don't support Message view
        var globalListViewTypeReact = getUserConfiguration().UserOptions.GlobalListViewTypeReact ||
            0 /* Conversation */;
        return globalListViewTypeReact === 0 /* Conversation */;
    }
    return false;
}
//# sourceMappingURL=isSubjectPickerSupported.js.map